import {DataRouterApplicationBuilder} from '@github-ui/react-core/future/data-router-application'

export const reactSandboxFutureAppBuilder = DataRouterApplicationBuilder.create('react-sandbox-future')
